import { useCallback } from "react";
import { sendGTMEvent } from "@next/third-parties/google";
import { FILTER_CATEGORY_MAP } from "./useHotelLandingFilterDataLayer";

/**
 * Search sayfası filtre category map (landing + search’e özel alanlar)
 */
export const SEARCH_FILTER_CATEGORY_MAP = {
  ...FILTER_CATEGORY_MAP,
  board: "Board type",
  chain: "Chain",
  price: "Price range",
  discounted: "Discount",
  refundable: "Reservation conditions",
};

/**
 * Search sayfası sıralama id -> dataLayer filter_subcategory (sorting_applied)
 */
export const SEARCH_SORTING_TYPE_MAP = {
  "0": "recommended",  // Önerilen
  "1": "priceAsc",     // En Ucuz
  "6": "starsDesc",   // En Çok Yıldızlı
  "4": "ratingDesc",  // En Yüksek Puan
};

/**
 * Hotel search sayfasında filtre/sıralama uygulandığında dataLayer event’leri push eder.
 *
 * @returns {{ sendFilterAppliedEvent, sendSortingAppliedEvent, getSortingType }}
 */
export function useHotelSearchFilterDataLayer() {
  const getSortingType = useCallback((sortId) => {
    const id = String(sortId ?? "0");
    return SEARCH_SORTING_TYPE_MAP[id] ?? "recommended";
  }, []);

  const sendFilterAppliedEvent = useCallback(
    (filterCategory, filterSubcategory, sortingType) => {
      const resolvedSortingType =
        typeof sortingType === "string"
          ? sortingType
          : getSortingType(sortingType);

      sendGTMEvent({
        event: "custom_event",
        event_category: "filtering",
        event_action: "filter_applied",
        filter_product_category: "hotel",
        filter_category: filterCategory,
        filter_subcategory: filterSubcategory,
        sorting_type: resolvedSortingType,
      });
    },
    [getSortingType]
  );

  const sendSortingAppliedEvent = useCallback(
    (sortId) => {
      const filterSubcategory = getSortingType(sortId);
      sendGTMEvent({
        event: "custom_event",
        event_category: "filtering",
        event_action: "sorting_applied",
        filter_product_category: "hotel",
        filter_category: "sorting",
        filter_subcategory: filterSubcategory,
      });
    },
    [getSortingType]
  );

  return {
    sendFilterAppliedEvent,
    sendSortingAppliedEvent,
    getSortingType,
  };
}
